import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-success-modal',
    templateUrl: './success-modal.component.html',
    styleUrls: ['./success-modal.component.scss'],
})
export class SuccessModalComponent implements OnInit, OnDestroy {
    private doNotRefresh: boolean;
    isSuccessful: boolean = true;
    message: string;
    description: {
        text: string;
        linkText?: string;
        linkUrl?: string;
    };
    buttonText: string = 'OK';
    hasCloseButton: boolean = false;
    private reason: string;

    constructor(public bsModalRef: BsModalRef, public bsModalService: BsModalService, private router: Router) {}

    ngOnInit(): void {
        this.closeOnRouteChange();
    }

    ngOnDestroy(): void {
        if (!this.doNotRefresh) {
            this.bsModalService.setDismissReason('refresh');
        }
        if (this.reason) {
            this.bsModalService.setDismissReason(this.reason);
        }
    }

    private closeOnRouteChange(): void {
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            this.bsModalRef.hide();
        });
    }
}
